export default {
  layouts: {
    admin: {
      logout: 'Chiqish',
      employees: 'Xodimlar',
      pos: 'Kassalar',
    },
  },
};
